var map = {
	"./account.svg": "lNpt",
	"./basic_management.svg": "dfvW",
	"./business_management.svg": "OPvI",
	"./download.svg": "+H2/",
	"./drag.svg": "vRhf",
	"./goods.svg": "XNJ4",
	"./home.svg": "U9Ws",
	"./remove.svg": "VFDz",
	"./report.svg": "2nwU",
	"./system.svg": "Jax1",
	"./template.svg": "//Qc",
	"./upload.svg": "P/TB"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 45